module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confirm-point-step"
    }
  }, [_c('step-template', [_c('div', {
    attrs: {
      "slot": "back"
    },
    on: {
      "click": _vm.back
    },
    slot: "back"
  }, [_vm._v("←")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_vm._v("Is your point in the right place?")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('csf-button', {
    staticClass: "mr-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('csf-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("No")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49bb6f3e","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/ConfirmPointStep.vue
// module id = 169
// module chunks = 0